export default __webpack_public_path__ + "static/media/pdf-placeholder.51fe394c.svg";